import { login, logout, getInfo ,listcateall} from '@/api/login' 
import { canViewRepairAmount } from '@/utils/access'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    uid: 0,
    name: '',
    username: '',
    avatar: '',level:19,
    roles: [],
    menus: [],
    access: { roleCodes: [], homeRole: 'none', permissions: [] },
    canViewRepairAmount: false
  },

  mutations: {
    SET_ACCESS: (state, access) => {
      state.access = access
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_UID: (state, uid) => {
      state.uid = uid
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_LEVEL: (state, level) => {
      state.level = level
    },
    SET_CAN_VIEW_REPAIR_AMOUNT: (state, canViewRepairAmount) => {
      state.canViewRepairAmount = canViewRepairAmount
    }
    
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {  
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        login(username, userInfo.password,userInfo.code,userInfo.sid).then(response => {
          const data = response.data
          commit('SET_ACCESS', { roleCodes: [], homeRole: 'none', permissions: [] })
          const tokenStr = data.tokenHead+data.token
          window.localStorage.setItem('USERINFO', data);
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr);
          listcateall().then(res => {
            //获取所有参数保存本地缓存
            window.localStorage.setItem('VALUECODE', JSON.stringify(res.data));
            }) 
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (!Array.isArray(data.roleCodes) || !Array.isArray(data.permissions) || !data.homeRole) {
            reject('服务未提供统一角色信息，请更新后端')
            return
          }
          commit('SET_ACCESS', { id: data.id, uid: data.id, roleCodes: data.roleCodes, homeRole: data.homeRole, permissions: data.permissions })
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('用户无角色权限')
          } 
          commit('SET_UID', data.id)
          commit('SET_MENUS', data.menus)
          commit('SET_USERNAME', data.username)
          commit('SET_NAME', data.nickname)
          commit('SET_AVATAR', data.icon)
          commit('SET_LEVEL', data.level)
          commit('SET_CAN_VIEW_REPAIR_AMOUNT', canViewRepairAmount(data))
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ACCESS', { roleCodes: [], homeRole: 'none', permissions: [] })
          commit('SET_ROLES', [])
          commit('SET_CAN_VIEW_REPAIR_AMOUNT', false)
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_ACCESS', { roleCodes: [], homeRole: 'none', permissions: [] })
        commit('SET_CAN_VIEW_REPAIR_AMOUNT', false)
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js